import { router } from '@inertiajs/react';

import BookingParameters from '../../../types/BookingParameters';
import compileUrlForParameters from '../helpers/compileUrlForParameters';
import RequestedDates from '../types/RequestedDates';

const useFetchDates =
    (actionUrl: string, parameters: BookingParameters) =>
    (dates: RequestedDates | undefined) => {
        const url = compileUrlForParameters(actionUrl, {
            ...parameters,
            pickupDate: dates?.pickupDate.toString(),
            requestedPickupDate: dates?.pickupDate.toString(),
            requestedReturnDate: dates?.returnDate.toString(),
        });

        router.visit(url, {
            preserveState: true,
            preserveScroll: true,
            replace: true,
        });
    };

export default useFetchDates;
